var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"im-switch ma-0 pa-0",attrs:{"inset":"","hide-details":"","color":"white","ripple":false},model:{value:(_vm.c_value),callback:function ($$v) {_vm.c_value=$$v},expression:"c_value"}})}
var staticRenderFns = []

export { render, staticRenderFns }